// extracted by mini-css-extract-plugin
module.exports = {"questions":"faq_questions__3OwZc","title":"faq_title__3Fm-N","container":"faq_container__1iFAG"};